module.exports = __webpack_public_path__ + "media/shared/images/banner-vettedByBrightFunds-25acd29d221cf50ca8b1669c24bb5717.svg";